var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TOOLBAR_ITEM_TYPE } from "../../Toolbar";
export function toolbarAction(_a) {
    var groupId = _a.groupId, title = _a.title, icon = _a.icon, id = _a.id, _b = _a.isAction, isAction = _b === void 0 ? true : _b, decorators = _a.decorators, handler = _a.handler, _c = _a.contextMenu, contextMenu = _c === void 0 ? true : _c, disabled = _a.disabled, hidden = _a.hidden;
    var result = function () {
        return {
            groupId: groupId,
            id: id,
            type: TOOLBAR_ITEM_TYPE.button,
            text: title,
            iconSrc: icon,
            onClick: function () { return handler === null || handler === void 0 ? void 0 : handler(); },
            isAction: isAction,
            disabled: disabled,
            hidden: hidden,
            decorators: decorators
        };
    };
    if (contextMenu) {
        result.contextMenu = __assign({ id: id, icon: icon,
            title: title,
            disabled: disabled,
            hidden: hidden,
            decorators: decorators,
            handler: handler }, (typeof contextMenu === 'object' ? contextMenu : {}));
    }
    return result;
}
//# sourceMappingURL=toolbarAction.js.map